export default "__VITE_ASSET__71taxQDr__"